import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) {
      console.error('ErrorBoundary caught:', error, info.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
          <div className="text-center p-4" style={{ maxWidth: 480 }}>
            <div className="avatar-lg mx-auto mb-4">
              <span className="avatar-title rounded-circle bg-danger-subtle">
                <i className="ri-error-warning-line text-danger" style={{ fontSize: '2rem' }}></i>
              </span>
            </div>
            <h4 className="mb-2">Something went wrong</h4>
            <p className="text-muted mb-4">
              An unexpected error occurred. Please refresh the page to try again.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
